<template>
  <div class="updatePwd">
    <div class="flex-inp">
      <span>原密码：</span>
      <input type="text" v-model.trim="oldPwd"/>
    </div>
    <div class="flex-inp">
      <span>新密码：</span>
      <input type="password" v-model.trim="newPwd"/>
    </div>
    <div class="flex-inp">
      <span>确认密码：</span>
      <input type="password" v-model.trim="againNewPwd"/>
    </div>
    <button class="btn" @click="confirm">确认</button>
  </div>
</template>

<script>
import { updatePwd } from '@/api/common'

export default {
  data () {
    return {
      oldPwd: '',
      newPwd: '',
      againNewPwd: ''
    }
  },
  methods: {
    async confirm () {
      if (!this.oldPwd || !this.newPwd || !this.againNewPwd) {
        this.$toast.fail('请输入完整数据')
        return
      }

      if (this.newPwd !== this.againNewPwd) {
        this.$toast.fail('两次输入的密码不一致，请重新输入')
        return
      }
      const result = await updatePwd(this.oldPwd, this.newPwd, this.againNewPwd)
      this.$toast.success(result.data)
      // 密码修改成功后退出登录
      this.$store.commit('removeUserInfo')
      this.$router.push('/').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err // 重新抛出其他类型的错误
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.updatePwd {
  margin: 50px auto;
  width: 500px;
  height: 500px;
  padding: 30px;
  .flex-inp {
    display: flex;
    margin: 20px 0;
    span {
      width: 20%;
      line-height: 32px;
    }
    input {
      width: 80%;
      height: 32px;
      padding: 4px 7px;
      font-size: 14px;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      color: #515a6e;
      background-color: #fff;
      background-image: none;
      cursor: text;
    }
  }
  .btn {
    width: 100%;
    height: 35px;
    text-align: center;
    cursor: pointer;
    padding: 0 15px;
    font-size: 16px;
    border-radius: 4px;
    color: #fff;
    background-color: #2d8cf0;
    border-color: #2d8cf0;
    margin-top: 10px;
  }
}
</style>
